/**
 * The Three Rivers rating selector: 3 Rivers (must-go) / 2 Rivers (great) / 1 River (good) /
 * "Wasn't for me" (no rivers). Each option shows the water-wave glyph; the selected option
 * gets a gold ring. Required for a rating-only submit.
 */
import { RATING_ORDER, RIVERS, type RatingValue } from '@pghbites/shared';
import { WaveGlyph } from './WaveGlyph.js';

interface RiverRatingProps {
  value: RatingValue | null;
  onChange: (value: RatingValue) => void;
}

export function RiverRating({ value, onChange }: RiverRatingProps) {
  return (
    <fieldset className="river-rating" aria-label="Rating (Three Rivers)">
      <div className="river-grid" role="radiogroup" aria-label="Three Rivers rating">
        {RATING_ORDER.map((v) => {
          const selected = value === v;
          return (
            <button
              key={v}
              type="button"
              role="radio"
              aria-checked={selected}
              className={`river-option${selected ? ' is-selected' : ''}`}
              onClick={() => onChange(v)}
            >
              <span className="river-waves">
                <WaveGlyph count={Number(v) as 0 | 1 | 2 | 3} />
              </span>
              <span className="river-label">{RIVERS[v].label}</span>
              <span className="river-blurb">{RIVERS[v].blurb}</span>
            </button>
          );
        })}
      </div>
    </fieldset>
  );
}
